// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__9AeXo","tooltip__tooltip":"styles_tooltip__tooltip__txVjz"};